import { dictionary } from "./dictionary"

const getsource = (value) => {
	let documentType = ""
	let keyExists = false
	let otherType = ""

	if (dictionary.hasOwnProperty(value)) {
		documentType = dictionary[value]
		keyExists = true
	}

	if (keyExists === false) {
		if (value !== undefined) {
			let example = value
			otherType = example
				.split("_")
				.reduce((a, b) => a.charAt(0).toUpperCase() + a.slice(1) + " " + b.charAt(0).toUpperCase() + b.slice(1))

			return { __html: `<span className="font10"><i className="far fa-file"></i> ${otherType}</span>` }
		}
	}

	if (documentType === dictionary.doc || documentType === dictionary.docx) {
		return { __html: `<span className="font10"><i className="far fa-file-word"></i> ${dictionary.doc}</span>` }
	}

	if (documentType === dictionary.email) {
		return { __html: `<span className="font10"><i className="far fa-envelope"></i> ${dictionary.email}</span>` }
	}

	if (documentType === dictionary.pdf) {
		return { __html: `<span className="font10"><i className="far fa-file-pdf"></i> ${dictionary.pdf}</span>` }
	}

	if (documentType === dictionary.pptx || documentType === dictionary.ppt) {
		return { __html: `<span className="font10"><i className="far fa-file-powerpoint"></i> ${dictionary.pptx}</span>` }
	}

	if (documentType === dictionary.xls || documentType === dictionary.xlsx) {
		return { __html: `<span className="font10"><i className="bi bi-file-earmark-excel"></i> ${dictionary.xls}</span>` }
	}

	if (documentType === dictionary.txt || documentType === dictionary.log) {
		return { __html: `<span className="font10"><i className="bi bi-file-earmark-text"></i> ${dictionary.txt}</span>` }
	}
}

const getFilter = (sourceApi) => {
	let jsonFilter = {}
	let keyExists = false
	let otherType = ""
	let jsonFilterAux = []

	try {
		sourceApi.forEach(function (key, value) {
			let human = getHumanValue(key)
			if (jsonFilterAux.find((element) => element === human) === undefined) {
				jsonFilter = { ...jsonFilter, [key]: true }
				jsonFilterAux.push(human)
			}
		})
	} catch (e) {}

	return jsonFilter
}

const getHumanValue = (value) => {
	if (dictionary.hasOwnProperty(value)) {
		return dictionary[value]
	}

	let example = value
	return example.split("_").reduce((a, b) => a.charAt(0).toUpperCase() + a.slice(1) + " " + b.charAt(0).toUpperCase() + b.slice(1))
}

const getKeyArrayHumanValue = (humanValue) => {
	var matched = Object.keys(dictionary).filter(function (key) {
		return dictionary[key] === humanValue
	})

	return matched
}

export const sourceHelper = {
	getsource,
	getFilter,
	getHumanValue,
	getKeyArrayHumanValue,
}
